"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var renderes_1 = require("./renderes");
var Popover_1 = require("../../Popover");
var helpers_1 = require("../../helpers");
var DROPDOWN_WIDTH;
(function (DROPDOWN_WIDTH) {
    DROPDOWN_WIDTH["controlWidth"] = "controlWidth";
    DROPDOWN_WIDTH["minControlWidthAndMaxXXL"] = "minControlWidthAndMaxXXL";
})(DROPDOWN_WIDTH = exports.DROPDOWN_WIDTH || (exports.DROPDOWN_WIDTH = {}));
var createDropdownStyle = function (width, popoverWidth) {
    if (width && popoverWidth === DROPDOWN_WIDTH.controlWidth) {
        return {
            width: width
        };
    }
    if (width && popoverWidth === DROPDOWN_WIDTH.minControlWidthAndMaxXXL) {
        return {
            minWidth: width,
            maxWidth: parseInt(helpers_1.FIELD_XXL, 10)
        };
    }
    return {};
};
function useDropdown(_a) {
    var ref = _a.ref, initialActiveState = _a.initialActiveState, _b = _a.autoClosable, autoClosable = _b === void 0 ? true : _b, renderContent = _a.renderContent, renderControl = _a.renderControl, popoverConfig = _a.popoverConfig, _c = _a.renderPopover, renderPopover = _c === void 0 ? renderes_1.defaultPopoverRenderer : _c, _d = _a.offset, offset = _d === void 0 ? 0 : _d, getAdditionalContentNode = _a.getAdditionalContentNode, onDidHide = _a.onDidHide, onDidShow = _a.onDidShow, dropdownWidth = _a.dropdownWidth, onOutsideClick = _a.onOutsideClick;
    var isActiveRef = react_1.useRef(!!initialActiveState);
    var actionsRef = react_1.useRef(null);
    var shownStateValue = helpers_1.useStateValue(!!initialActiveState, [initialActiveState], {
        onReset: function (nextValue) {
            var _a, _b;
            nextValue ? (_a = actionsRef.current) === null || _a === void 0 ? void 0 : _a.show() : (_b = actionsRef.current) === null || _b === void 0 ? void 0 : _b.hide();
        }
    });
    var actions = {
        hide: function () {
            isActiveRef.current = false;
            shownStateValue.setValue(false);
            onDidHide === null || onDidHide === void 0 ? void 0 : onDidHide();
        },
        show: function () {
            isActiveRef.current = true;
            shownStateValue.setValue(true);
            onDidShow === null || onDidShow === void 0 ? void 0 : onDidShow();
        },
        toggle: function () {
            var nextValue;
            shownStateValue.updateValue(function (value) {
                nextValue = !value;
                isActiveRef.current = nextValue;
                return nextValue;
            });
            nextValue ? onDidShow === null || onDidShow === void 0 ? void 0 : onDidShow() : onDidHide === null || onDidHide === void 0 ? void 0 : onDidHide();
        }
    };
    actionsRef.current = actions;
    var _e = Popover_1.useMeasureClientRect(ref), measureRef = _e[0], measurableControl = _e[1];
    var measureButton = measurableControl.measure();
    var controlReactNode = renderControl({
        isActive: shownStateValue.getValue(),
        actions: actions,
        button: {
            ref: measureRef,
            onMouseDown: function (mouseEvent) {
                if (mouseEvent) {
                    mouseEvent.preventDefault();
                }
                actions.toggle();
            }
        }
    });
    var popover = Popover_1.usePopover({
        isActive: shownStateValue.getValue(),
        config: popoverConfig || [
            {
                xAxis: Popover_1.X_AXIS.insideLeft,
                yAxis: Popover_1.Y_AXIS.outsideBottom,
                offsetY: offset * -1
            },
            {
                xAxis: Popover_1.X_AXIS.insideRight,
                yAxis: Popover_1.Y_AXIS.outsideBottom,
                offsetY: offset * -1
            },
            { xAxis: Popover_1.X_AXIS.insideLeft, yAxis: Popover_1.Y_AXIS.outsideTop, offsetY: offset },
            { xAxis: Popover_1.X_AXIS.insideRight, yAxis: Popover_1.Y_AXIS.outsideTop, offsetY: offset }
        ],
        target: measurableControl,
        onKeyPress: function (e) {
            if (e.keyCode === helpers_1.KeyCode.Escape) {
                if (autoClosable && shownStateValue.getValue()) {
                    actions.hide();
                }
            }
        },
        onOutsideClick: autoClosable && shownStateValue.getValue()
            ? function (e) {
                actions.hide();
                onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick(e);
            }
            : undefined,
        getAdditionalContentNode: function () {
            var _a;
            return __spreadArrays(((_a = getAdditionalContentNode === null || getAdditionalContentNode === void 0 ? void 0 : getAdditionalContentNode()) !== null && _a !== void 0 ? _a : []), [
                measurableControl.getDOMNode()
            ]);
        },
        render: function (popoverRef) {
            var _a;
            return renderPopover({
                popover: {
                    ref: popoverRef,
                    style: __assign({}, createDropdownStyle(measureButton === null || measureButton === void 0 ? void 0 : measureButton.width, dropdownWidth))
                },
                actions: actions,
                content: (_a = renderContent === null || renderContent === void 0 ? void 0 : renderContent({ actions: actions })) !== null && _a !== void 0 ? _a : null
            });
        }
    });
    var controlNode = react_1.default.createElement(react_1.default.Fragment, null, controlReactNode, shownStateValue.getValue() && popover);
    return [
        controlNode,
        {
            isActive: shownStateValue.getValue(),
            deactivate: actions.hide,
            activate: actions.show
        }
    ];
}
exports.useDropdown = useDropdown;
//# sourceMappingURL=hooks.js.map